import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Component, HostListener, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { SharedService } from '../shared.service';
import { Subscription } from 'rxjs';
import { LoaderService } from './loader-service.component';
import { SpinnerService } from './spinner.service';

@AutoUnsubscribe()
@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html'
})
export class SpinnerComponent implements OnInit, AfterViewInit, OnDestroy {
    color = 'primary';
    mode = 'indeterminate';
    value = 50;
    pageWidthCenter = 0;
    pageHeightCenter = 0;
    hideSpinner: boolean;
    hideSpinnerSubscription: Subscription;
    showSpinner: boolean;
    showSpinnerSharedSubscription: Subscription;
    showSpinnerSubscription: Subscription;
    loading = false;
    loadingChain = [];

    constructor(
        private sharedService: SharedService,
        private loaderService: LoaderService,
        private spinnerService: SpinnerService) {}

    @HostListener('window:resize', ['$event'])
    onResize(event?) {
        setTimeout(() => {
            this.pageWidthCenter = window.innerWidth / 2 - 50;
            this.pageHeightCenter = window.innerHeight / 2 - 50;
        }, 0);
    }

    ngOnInit() {
        this.showSpinnerSharedSubscription = this.sharedService.observableShowSpinnerStream$.subscribe(
            data => {
                setTimeout(() => {
                    this.showSpinner = data;
                }, 0);
            }
        );
        this.hideSpinnerSubscription = this.spinnerService.observableHideSpinnerStream$.subscribe(result => {
            this.hideSpinner = result;
        });
        this.showSpinnerSubscription = this.spinnerService.observableShowSpinnerStream$.subscribe(result => {
            this.showSpinner = result;
        });

        this.loaderService.isLoading.subscribe(result => {
            this.loadingChain.push(result);
            setTimeout(() => {
                this.loadingChain.pop();
                if (this.loadingChain.length == 0) {
                    this.loading = result;
                }
            }, 0);
        });
    }

    ngOnDestroy() {}

    ngAfterViewInit() {
        this.onResize();
    }
}